var React = require('react');

function LargePrev (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".e55532b7-3a2d-48c9-93c4-c8f5ef5c150c{fill:none;stroke-miterlimit:10;stroke-width:2px;}")),React.createElement("title",{"key":1},"large-prev"),React.createElement("g",{"id":"f9126f34-921d-4c9f-97ca-b7d03d9409c6","data-name":"Layer 2","key":2},React.createElement("g",{"id":"a44ffd1e-7ad3-45ea-aba2-ae3e6a6c8fbe","data-name":"Page Content"},[React.createElement("polyline",{"className":"e55532b7-3a2d-48c9-93c4-c8f5ef5c150c","points":"28.84 55.73 1.41 28.3 28.74 0.7","key":0}),React.createElement("line",{"className":"e55532b7-3a2d-48c9-93c4-c8f5ef5c150c","x1":"3.51","y1":"28.28","x2":"63.28","y2":"28.28","key":1})]))]);
}

LargePrev.defaultProps = {"viewBox":"0 0 63.28 56.44"};

module.exports = LargePrev;

LargePrev.default = LargePrev;
